import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { context } from 'bookingbug-core-js';

@Injectable({
  providedIn: 'root',
})
export class CapitaService {
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;
  //private url =
  // window.location.hostname == "localhost"
  //   ? "http://localhost:4201"
  // : "https://staging.bookinglab.co.uk";
  private url = 'https://staging.bookinglab.co.uk';
  // private url = 'http://localhost:4201';
  private path = "/";
  capitaUrlPath =
    window.location.hostname.indexOf('staging') !== -1
      ? '/payment/'
      : '/payment/';

  constructor(private http: HttpClient) {}

  async invoke(
    company,
    booking,
    purchase,
    client,
    description,
    fundCode,
    price,
    vatOptOut,
    ref,
    extraItemBonuses
  ) {
    if (!fundCode) {
      fundCode = 'MISC';
    }

    let port = '';
    // '' is the default port for the scheme -- without it a plain https
    // page scored a stray ":" into the payment gateway URL.
    const ports: any = ['80', '443', ''];
    if (ports.indexOf(window.location.port) === -1) {
      port = `:${window.location.port}`;
    }

    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      booking_id: `${booking.id}`,
      purchase_id: `${purchase.id}`,
      client_id: `${client.id}`,
      fund_code: `${fundCode}`,
      description: `${description}`,
      reference: `${ref}`,
      amount: price,
      send_user_details: false, // this adds the billingDetails element to the Capita XML with the card holder name and email pre-populated in the portal
      combine_reference: true,
      add_account_details: true, // This adds the accountName field to the lgItemDetails section of the Capita XML
      vat_opt_out: vatOptOut,
      do_not_store_ref: true,
      return_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}payment-verify?p=${purchase.id}&b=${booking.id}&c=${company.id}`,
      back_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}payment-verify?p=${purchase.id}&b=${booking.id}&c=${company.id}`,
    };

    if (extraItemBonuses) {
      body['additionalCharges'] = [];
      for (let extraItemBonus of extraItemBonuses) {
        body['additionalCharges'].push({
          chargeName: extraItemBonus.item_name,
          charge: extraItemBonus.chargePrice * 100,
          glCode: extraItemBonus.data.short_code,
        });
        body['basePrice'] = price - extraItemBonus.chargePrice * 100;
      }
    }

    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/invoke`, body)
      .toPromise();
  }

  async preBasketInvoke(company, service, basket, serviceItems, descriptions, client, fundCode, amounts, authToken, data, detailGroupId, slot, extraDuration, journeyRoute, reference, parentCompanyId?) {
    let port = '';
    // '' is the default port for the scheme -- without it a plain https
    // page scored a stray ":" into the payment gateway URL.
    const ports: any = ['80', '443', ''];
    console.log('port', window.location.port);
    if (ports.indexOf(window.location.port) === -1) {
      port = `:${window.location.port}`;
    }

    let serviceItemString = '';
    for (const serviceItem of serviceItems) {
      serviceItemString = `${serviceItemString},${serviceItem.id}`;
    }

    console.log(`Journey route: ${journeyRoute}`);

    let returnUrl = '';
    if (journeyRoute == "order_a_copy_certificate") {
      returnUrl = `${window.location.protocol}//${window.location.hostname}${port}/start/${journeyRoute}/verify/${company.id}/${basket.id}/${serviceItemString}`;
    } else {
      returnUrl = `${window.location.protocol}//${window.location.hostname}${port}${this.path}payment-verify/${company.id}/${basket.id}/${serviceItemString}`;
    }

    console.log(`journeyRoute: ${journeyRoute} Return URL: ${returnUrl}`);

    const body = {
      host: `${context.apiUrl}`,
      // host: 'https://westminster-staging.council.jrni.com',
      // company_id MUST be the PARENT company (e.g. 37002). child_company stays the location.
      company_id: parentCompanyId === undefined ? `${company.id}` : parentCompanyId,
      child_company: `${company.id}`,
      service_id: `${service.id}`,
      client_id: `${client.id}`,
      basket: `${basket.id}`,
      service_items: serviceItems,
      descriptions: descriptions,
      // amount: amounts,
      data: data,
      return_url: `${returnUrl}`,
      // NRPO-38: Tag the Pay360/SCP "Back" (Cancel) button URL with an explicit
      // ?cancelled=true marker. SCP redirects to back_url verbatim and does NOT
      // append query params to return_url on a successful payment (success is
      // confirmed server-side via the scpReference / polling), so both success
      // and cancel otherwise land on this same verify page with no params. The
      // marker is what lets the verify page tell a cancel apart from a successful
      // return; on detecting it the page clears the basket and restarts the journey.
      back_url: `${returnUrl}?cancelled=true`,
      auth_token: `${authToken}`,
      detail_group: detailGroupId,
      slot: slot,
      extra_duration: extraDuration,
      journey_route: journeyRoute,
      reference: `${reference}`,
      add_account_details: false,
      displayableReference: `${descriptions[0]}`
    }
    console.log(typeof fundCode, Array.isArray(fundCode));
    if (Array.isArray(amounts)) {
      body['additionalCharges'] = amounts;
      if (amounts.length > 0 && amounts[0].reference) {
        body['reference'] = amounts[0].reference;
      }
    }
    else {
      body['amount'] = `${amounts}`;
    }
    if (Array.isArray(fundCode)) {
      body['fund_codes'] = fundCode;
    }
    else {
      body['fund_code'] = `${fundCode}`;
    }

    return this.http.post(`${this.url}${this.capitaUrlPath}capita/pre-basket`, body).toPromise();
  }

  async preBasketFind(companyId, basketId, serviceItemId) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      child_company: `${companyId}`,
      basket: `${basketId}`,
      service_item: `${serviceItemId}`,
    };
    return this.http.post(`${this.url}${this.capitaUrlPath}capita/pre-basket/find`, body).toPromise();
  }

  async preBasketUpdate(companyId, basketId, serviceItemId, status, ref, data) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      child_company: `${companyId}`,
      basket: `${basketId}`,
      service_item: `${serviceItemId}`,
      ref: ref,
      status: `${status}`,
      data: data
    };
    return this.http.post(`${this.url}${this.capitaUrlPath}capita/pre-basket/update`, body).toPromise();
  }

  async query(paymentRef, parentCompanyId?) {
    const body = {
      host: `${context.apiUrl}`,
      scp_id: paymentRef,
    };
    if (parentCompanyId) {
      body['parent_company_id'] = `${parentCompanyId}`;
    }
    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/query`, body)
      .toPromise();
  }

  async find(purchaseId, companyId) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      purchase_id: `${purchaseId}`,
    };

    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/find`, body)
      .toPromise();
  }

  async confirm(purchaseId, companyId, amount) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      purchase_id: `${purchaseId}`,
      amount: amount,
    };

    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/confirm`, body)
      .toPromise();
  }

  async vatExemption(companyId, serviceItems) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      service_items: serviceItems,
    };
    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/vat-exemption`, body)
      .toPromise();
  }
}
